import apiService from 'frontcore/data/api-service/api-service'
import {
  PersonMin,
  PersonMinAPIResponse,
} from 'frontend/presentation/not-authorization/types'

const url = 'administrators'

const parseAdministratorsResponse = (response: PersonMinAPIResponse[]): PersonMin[] => {
  return response.map(adminApiResponse => ({
    id: adminApiResponse.id,
    created: adminApiResponse.created,
    updated: adminApiResponse.updated,
    active: adminApiResponse.active,
    email: adminApiResponse.email,
    employeeId: adminApiResponse.employee_id,
    isAdministrator: adminApiResponse.is_administrator,
    name: adminApiResponse.name,
    role: adminApiResponse.role,
  }))
}

const notAuthorizationAPIClient = () => {
  const getAdministrators = async () => {
    const response = await apiService
      .buildRequest()
      .withSessionToken()
      .get<PersonMinAPIResponse[]>(url)
    const parsedResponse = parseAdministratorsResponse(response.data)
    return parsedResponse
  }

  return {
    getAdministrators,
  }
}

export default notAuthorizationAPIClient
